exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media print {\n  @page {} }\n\n.extra-details-container {\n  max-width: 400px;\n  word-break: break-word;\n  white-space: wrap; }\n\n.margin-top-30 {\n  margin-top: 30px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/tnt_billing/components/contract/edit/print/print_history.scss
// module id = 1109
// module chunks = 1